"use client";

import { c as _c } from "react/compiler-runtime";
import { useResolvedIpfsUrl } from "@/hooks/useResolvedIpfsUrl";
import Image from "next/image";
function getLevelBgColor(level: number) {
  if (level >= 80) return "tw-bg-[#55B075] tw-text-black";
  if (level >= 60) return "tw-bg-[#AABE68] tw-text-black";
  return "tw-bg-[#DA8C60] tw-text-white";
}
export default function HeaderSearchModalPfp(t0) {
  const $ = _c(18);
  const {
    src,
    alt,
    level,
    size: t1
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const {
    data: resolved
  } = useResolvedIpfsUrl(src);
  let t2;
  if ($[0] !== level) {
    t2 = getLevelBgColor(level);
    $[0] = level;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const levelColor = t2;
  if (!resolved) {
    let t3;
    if ($[2] !== size) {
      t3 = {
        width: size,
        height: size
      };
      $[2] = size;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const t4 = `tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold ${levelColor}`;
    let t5;
    if ($[4] !== level || $[5] !== t3 || $[6] !== t4) {
      t5 = <div style={t3} className={t4}>{level}</div>;
      $[4] = level;
      $[5] = t3;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  const t3 = alt ?? "";
  let t4;
  if ($[8] !== resolved || $[9] !== size || $[10] !== t3) {
    t4 = <Image src={resolved} alt={t3} width={size} height={size} className="tw-rounded-full tw-object-cover" />;
    $[8] = resolved;
    $[9] = size;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = `tw-absolute tw-top-[-5px] tw-right-[-5px] tw-h-[18px] tw-w-[18px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-[8px] tw-font-semibold ${levelColor}`;
  let t6;
  if ($[12] !== level || $[13] !== t5) {
    t6 = <div className={t5}>{level}</div>;
    $[12] = level;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="tw-relative tw-inline-block">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}